import { render, staticRenderFns } from "./EmailAuthorizationModal.vue?vue&type=template&id=57fa6da0&scoped=true"
import script from "./EmailAuthorizationModal.vue?vue&type=script&lang=js"
export * from "./EmailAuthorizationModal.vue?vue&type=script&lang=js"
import style0 from "./EmailAuthorizationModal.vue?vue&type=style&index=0&id=57fa6da0&prod&scoped=true&lang=css"
import style1 from "./EmailAuthorizationModal.vue?vue&type=style&index=1&id=57fa6da0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fa6da0",
  null
  
)

export default component.exports